/* eslint-disable */
export default {
  copyToClipboard: 'クリップボードにコピー',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
